<template>
  <base-page-layout title="Mensagens" class="template-mensagens">
    <v-container class="pa-0" fluid>
      <mf-loading-dialog :loading="initialLoader">
        <v-row justify="end" class="mb-2 pr-3">
          <mf-button icon="add" label="Criar novo modelo" @click="$router.push('/configuracoes/mensagens/nova')" />
        </v-row>
        <v-card>
          <v-card-title class="px-6 pb-0">
            <v-row>
              <v-col cols="9">
                <span class="table-card-title">Configure seus modelos de mensagem</span>
                <p class="section-subtitle pt-1">Para facilitar a criação da sua campanha, temos algumas ideias de mensagens pra te oferecer.</p>
              </v-col>
              <v-col cols="3">
                <mf-search v-model.lazy="search" placeholder="Busca" hide-details />
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <paginated-data-table
              ref="messagesTemplateTable"
              :headers="headers"
              :search="search"
              :query="query"
              queryName="messageTemplates"
              queryMainPropertyName="templates"
              item-key="_id"
              no-data-text="Não existem dados a serem exibidos."
              :custom-items-per-page="10"
            >
              <template v-slot:item="{ item }">
                <tr>
                  <td class="nowrap-row">
                    <v-tooltip max-width="450" top>
                      <template v-slot:activator="{ on }">
                        <div class="message-ellipsis">
                          <span v-on="on">{{ item.message }}</span>
                        </div>
                      </template>
                      <span>{{ item.message }}</span>
                    </v-tooltip>
                  </td>
                  <td>{{ item.message_length }} caracteres</td>
                  <td>
                    <v-chip v-for="(channel, index) in item.channels" :key="index" class="ma-1">
                      <span>{{ formatChannelName(channel) }}</span>
                    </v-chip>
                  </td>

                  <td>
                    <message-tags
                      :template-tags.sync="item.tags"
                      :all-tags.sync="allTags"
                      :template="item"
                      @fetch-tags="fetchMessageTags"
                      @on-close="fetchMessageTemplates"
                    />
                  </td>

                  <td class="text-right">
                    <v-menu bottom origin="center center" transition="scale-transition">
                      <template v-slot:activator="{ on }">
                        <mf-button color="cinza-0" icon="more_vert" type="icon" v-on:click.native="on.click" />
                      </template>
                      <v-list>
                        <v-list-item @click="editMessage(item)">
                          <v-list-item-title>Editar</v-list-item-title>
                        </v-list-item>
                        <v-list-item @click="deleteMessage(item)">
                          <v-list-item-title>Deletar</v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </td>
                </tr>
              </template>
            </paginated-data-table>
          </v-card-text>
        </v-card>
      </mf-loading-dialog>
    </v-container>
  </base-page-layout>
</template>

<script>
import { QUERY_GET_MESSAGES, QUERY_GET_TAGS, MUTATION_DELETE_MESSAGE } from '@/modules/configuracoes/template-mensagens/graphql'
import { mapWaitingActions } from 'vue-wait'

export default {
  name: 'TemplateMensagens',
  components: {
    BasePageLayout: () => import('@/components/BasePageLayout.vue'),
    MessageTags: () => import('@/modules/configuracoes/template-mensagens/views/components/MessageTags.vue'),
    PaginatedDataTable: () => import('@/components/PaginatedDataTable.vue'),
  },
  data: () => ({
    search: '',
    items: [],
    showTooltipDescription: {},
    editing: false,
    selectedUnit: {},
    loading: false,
    initialLoader: false,
    localMessages: [],
    allMessages: [
      {
        _id: 1,
        message:
          '[Primeiro nome], seja bem vindo ao XXXX! Estamos felizes em ter vc conosco! Fique ligado nos nossos descontos pensados especialmente para vc.',
        size: 120,
        channels: ['SMS', 'Whatsapp'],
        tags: [
          {
            color: '#f0f4c3',
            name: 'BOAS VINDAS',
          },
          {
            color: '#6db500',
            name: 'Favorita',
          },
        ],
      },
      {
        _id: 2,
        message:
          '[Primeiro nome], seja bem vindo ao XXXX! Estamos felizes em ter vc conosco! Fique ligado nos nossos descontos pensados especialmente para vc.',
        size: 100,
        channels: ['PUSH', 'E-mail'],
        tags: [
          {
            color: '#8ad2bd',
            name: 'PUSH',
          },
          {
            color: '#f0f4c3',
            name: 'BOAS VINDAS',
          },
        ],
      },
    ],
    headers: [
      {
        text: 'Mensagem',
        value: 'message',
        width: '35%',
        sortable: false,
      },
      {
        text: 'Tamanho',
        value: 'size',
        width: '15%',
        sortable: false,
      },
      {
        text: 'Canais',
        value: 'channels',
        width: '23%',
        sortable: false,
      },
      {
        text: 'Marcadores',
        width: '30%',
        sortable: false,
      },
      {
        text: '',
        sortable: false,
      },
    ],
    allTags: [],
  }),
  computed: {
    query() {
      return QUERY_GET_MESSAGES
    },
  },
  mounted() {
    this.fetchMessageTags()
  },
  methods: {
    ...mapWaitingActions({
      fetchUnits: 'fetch-units',
    }),
    formatChannelName(channel) {
      if (channel === 'SMS') return 'SMS'
      if (channel === 'WHATSAPP') return 'Whatsapp'
      if (channel === 'PUSH') return 'Push'
      if (channel === 'EMAIL') return 'E-mail'
    },
    async fetchMessageTags() {
      try {
        this.loading = true
        const {
          data: {
            messageTemplateTags: { tags },
          },
        } = await this.$apollo.query({
          query: QUERY_GET_TAGS,
          fetchPolicy: 'no-cache',
        })
        this.allTags = tags
      } catch (e) {
        this.$snackbar({ message: 'Ocorreu um erro ao carregar as tags de mensagem.' })
        console.log(e)
      } finally {
        this.loading = false
      }
    },
    async fetchMessageTemplates() {
      await this.$refs.messagesTemplateTable.waitAndGetData()
    },
    async editMessage(message) {
      this.$router.push({ path: `/configuracoes/mensagens/${message._id}` }).catch(() => {})
    },
    async deleteMessage(message) {
      const confirmed = await this.$confirm({
        title: 'Remover mensagem',
        message: 'Tem certeza que deseja remover a mensagem? Modelos de mensagem apagados não podem ser recuperados.',
        confirmText: 'Remover',
        confirmColor: 'vermelho-d20',
        cancelText: 'Cancelar',
      })
        .then(() => true)
        .catch(() => false)
      if (!confirmed) return
      const { _id } = message
      try {
        await this.$apollo.mutate({
          mutation: MUTATION_DELETE_MESSAGE,
          variables: { _id },
        })
        this.$snackbar({ message: 'Modelo apagado com sucesso!', snackbarColor: 'success' })
      } catch (error) {
        console.log(error)
      } finally {
        await this.fetchMessageTemplates()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.template-mensagens {
  .message-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }
  th {
    @extend .column-title;
  }
  td {
    padding: 10px;
    @extend .texto-corrido;
    & span {
      line-height: 150% !important;
    }
  }
  .section-subtitle {
    @extend .texto-corrido;
    word-break: break-word;
  }
  .list-enter-active,
  .list-leave-active {
    transition: all 0.4s;
  }
  .list-enter,
  .list-leave-to {
    opacity: 0;
    transform: translateY(100%);
  }
  .list-move {
    transition: transform 0.4s;
  }
  .list-item {
    display: table-row;
  }
}
</style>
